import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Teleport as _Teleport, createBlock as _createBlock, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/icons/cloud-upload.svg'
import _imports_1 from '@/assets/icons/document.svg'
import _imports_2 from '@/assets/icons/xmark.svg'
import _imports_3 from '@/assets/icons/check-circle-green.svg'
import _imports_4 from '@/assets/icons/error-circle-red.svg'
import _imports_5 from '@/assets/icons/chevron-down-white.svg'
import _imports_6 from '@/assets/icons/white-checkmark.svg'
import _imports_7 from '@/assets/icons/caution.svg'


const _hoisted_1 = {
  key: 0,
  class: "mt-4 bg-yellow-300 rounded-xl border border-yellow-500/40 p-4 flex items-center gap-3"
}
const _hoisted_2 = { class: "mt-6 grid grid-cols-1 lg:grid-cols-3 gap-6 items-start" }
const _hoisted_3 = { class: "flex flex-col gap-6" }
const _hoisted_4 = { class: "bg-layer-2 rounded-xl border border-stroke-separator p-6 flex flex-col" }
const _hoisted_5 = { class: "flex-1 min-w-0" }
const _hoisted_6 = { class: "flex items-center justify-between gap-3" }
const _hoisted_7 = { class: "text-text-neutral-extreme font-medium truncate" }
const _hoisted_8 = {
  key: 0,
  class: "inline-block w-3.5 h-3.5 border-2 border-elements-blue border-t-transparent rounded-full animate-spin"
}
const _hoisted_9 = {
  key: 1,
  src: _imports_3,
  class: "w-3.5 h-3.5",
  alt: ""
}
const _hoisted_10 = {
  key: 2,
  src: _imports_4,
  class: "w-3.5 h-3.5",
  alt: ""
}
const _hoisted_11 = { class: "mt-3 h-1.5 w-full rounded-full bg-layer-2 overflow-hidden" }
const _hoisted_12 = {
  key: 0,
  class: "flex items-center justify-between text-xs text-text-neutral-medium mt-1.5"
}
const _hoisted_13 = { class: "bg-layer-2 rounded-xl border border-stroke-separator p-6" }
const _hoisted_14 = { class: "mb-4" }
const _hoisted_15 = { class: "mb-4" }
const _hoisted_16 = {
  key: 0,
  class: "mt-2 text-sm text-elements-red"
}
const _hoisted_17 = {
  key: 1,
  class: "mt-2 text-sm text-elements-red"
}
const _hoisted_18 = { class: "mb-5" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "lg:col-span-2 bg-layer-2 rounded-xl border border-stroke-separator overflow-hidden" }
const _hoisted_21 = { class: "flex items-center justify-between gap-4 px-6 py-4 border-b border-stroke-separator" }
const _hoisted_22 = { class: "flex items-center gap-1 bg-layer-0 border border-stroke-separator rounded-lg p-1 shrink-0" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "flex items-center gap-4" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "relative" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  key: 0,
  class: "px-6 py-8 text-sm text-text-neutral-medium"
}
const _hoisted_29 = {
  key: 1,
  class: "relative w-full overflow-x-auto"
}
const _hoisted_30 = { class: "min-w-[900px] w-full text-sm table-fixed" }
const _hoisted_31 = { class: "divide-y divide-stroke-separator" }
const _hoisted_32 = { class: "py-4 pl-6 pr-3 relative" }
const _hoisted_33 = { class: "flex items-stretch gap-3" }
const _hoisted_34 = {
  key: 0,
  class: "w-1 rounded-full bg-elements-blue shrink-0"
}
const _hoisted_35 = { class: "min-w-0 flex-1" }
const _hoisted_36 = {
  key: 0,
  class: "text-xs text-elements-red mb-2"
}
const _hoisted_37 = {
  key: 1,
  class: "text-xs text-elements-red mb-2"
}
const _hoisted_38 = ["src", "alt"]
const _hoisted_39 = { class: "text-sm truncate flex-1 text-left" }
const _hoisted_40 = { class: "font-medium text-text-neutral-extreme truncate" }
const _hoisted_41 = { class: "text-xs text-text-neutral-medium mt-0.5 truncate" }
const _hoisted_42 = { class: "py-4 px-3" }
const _hoisted_43 = { class: "py-4 px-3" }
const _hoisted_44 = { class: "flex items-center gap-3" }
const _hoisted_45 = ["disabled", "onClick"]
const _hoisted_46 = ["disabled", "onClick"]
const _hoisted_47 = { class: "relative inline-flex w-5 h-5 shrink-0" }
const _hoisted_48 = ["checked", "onChange"]
const _hoisted_49 = { class: "flex items-center justify-between px-4 py-4 border-t border-stroke-separator text-sm text-text-neutral-medium" }
const _hoisted_50 = { class: "flex flex-col items-center" }
const _hoisted_51 = { class: "font-inter text-[19px] font-semibold leading-[30px] mb-2 text-white" }
const _hoisted_52 = { class: "flex flex-col w-full" }

import { ref, computed, watch, onMounted, onUnmounted, inject } from 'vue'
import { useStore } from 'vuex'
import LanguagePicker from '@/components/session/LanguagePicker.vue'
import LanguageSelect from '@/components/ui/LanguageSelect.vue'
import SheetModal from '@/components/ui/SheetModal.vue'
import api from '@/services/api2.service'
import { useLanguages } from '@/composables/useLanguages'
import customVocabularyService from '@/services/custom-vocabulary.service'
import { getAllowedCharSet, getInvalidChars } from '@/services/vocabulary-charset.service'
import { Constants } from '@/cfg/constants'

interface VocabularyTerm {
  id: string
  text: string
  language: string
  displayed_as: string
  pending: boolean
  edited: boolean
}

interface AwsLanguageStatus {
  language: string
  id: string
  status: string
}

const SYNC_POLL_INTERVAL_MS = 60 * 1000
const MAX_BULK_WORDS = 100

interface BulkImportState {
  file: File | null
  status: 'idle' | 'uploading' | 'success' | 'error'
  progress: number
  loadedBytes: number
  message: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OrganizationVocabularyView',
  setup(__props) {

const store = useStore()
const organization = computed(() => store.getters['nonpersist/getUserOrganization'])
const organizationId = computed(() => organization.value?.id)
const toast = inject('toast') as { success: Function, error: Function } | undefined

function notifyError(err: any, fallback = 'Something went wrong') {
  const message = err?.response?.data?.error || fallback
  if (toast) toast.error(message)
  else console.error(message)
}

const listId = ref<string | null>(null)
const loading = ref(false)
const terms = ref<VocabularyTerm[]>([])
const selectedIds = ref<Set<string>>(new Set())

const awsIds = ref<AwsLanguageStatus[]>([])
const localSyncOverride = ref(false)
const awsSyncing = computed(() => awsIds.value.some(a => a.status !== 'ready' && a.status !== 'failed'))
const isVocabSyncing = computed(() => localSyncOverride.value || awsSyncing.value)

function mapTerm(raw: any): VocabularyTerm {
  return {
    id: raw.id ?? raw._id,
    text: raw.phrase ?? raw.term ?? '',
    language: raw.language,
    displayed_as: raw.display_as ?? raw.displayed_as ?? raw.phrase ?? raw.term ?? '',
    pending: false,
    edited: false
  }
}

async function fetchTerms() {
  if (!listId.value) return

  const { data } = await customVocabularyService.getTerms(listId.value)
  const result = data?.result
  const rawTerms = Array.isArray(result) ? result : (result?.terms ?? [])
  terms.value = rawTerms.map(mapTerm)
}

async function init() {
  if (!organizationId.value) return

  loading.value = true
  try {
    const { data } = await api.get(`/organization/info/${organizationId.value}`)
    const lists = data?.result?.custom_vocabulary_lists ?? []
    let list = lists[0]

    if (!list) {
      const created = await customVocabularyService.createList('Default Vocabulary', 'organization', organizationId.value)
      list = created.data?.result
    }

    listId.value = list?.id ?? list?._id ?? null
    awsIds.value = list?.aws_ids ?? []
    await fetchTerms()
  } catch (err) {
    notifyError(err, 'Failed to load custom vocabulary')
  } finally {
    loading.value = false
  }
}

let syncPollTimer: ReturnType<typeof setInterval> | null = null

async function checkSyncStatus() {
  if (!organizationId.value) return

  try {
    const { data } = await api.get(`/organization/info/${organizationId.value}`)
    const list = (data?.result?.custom_vocabulary_lists ?? [])[0]
    awsIds.value = list?.aws_ids ?? []

    if (!awsSyncing.value) {
      localSyncOverride.value = false
    }
  } catch (err) {
    // Keep the previous sync state if the check fails; the next poll will retry.
  }
}

onMounted(() => {
  init()
  syncPollTimer = setInterval(checkSyncStatus, SYNC_POLL_INTERVAL_MS)
})

onUnmounted(() => {
  if (syncPollTimer) clearInterval(syncPollTimer)
})

// ADD WORD FORM
const { getLanguageName } = useLanguages()

const form = ref({
  language: Constants.DEFAULT_LANGUAGE,
  term: '',
  displayed_as: ''
})

const DIGIT_WORDS = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine']
const WORD_TO_DIGIT: Record<string, string> = DIGIT_WORDS.reduce((acc, word, digit) => {
  acc[word] = String(digit)
  return acc
}, {} as Record<string, string>)

const termDigits = computed(() => (form.value.term.match(/\d/g) || []).join(''))
const termHasDigits = computed(() => termDigits.value.length > 0)
const termDigitsAsWords = computed(() => termDigits.value.split('').map(d => DIGIT_WORDS[Number(d)]).join('-'))

// CHARACTER SET VALIDATION
const addFormAllowedSet = ref<Set<number> | null>(null)

watch(() => form.value.language, async (lang) => {
  addFormAllowedSet.value = await getAllowedCharSet(lang)
}, { immediate: true })

const termInvalidChars = computed(() => getInvalidChars(form.value.term, addFormAllowedSet.value))
const termInvalidNonDigitChars = computed(() => termInvalidChars.value.filter(c => !/\d/.test(c)))

const canSubmit = computed(() => form.value.term.trim().length > 0 && !termHasDigits.value && termInvalidNonDigitChars.value.length === 0 && !isVocabSyncing.value)

const justEnabled = ref(false)

watch(canSubmit, (enabled, wasEnabled) => {
  if (enabled && !wasEnabled) {
    justEnabled.value = true
    setTimeout(() => { justEnabled.value = false }, 350)
  }
})

let tempIdCounter = 0

function nextTempId(): string {
  tempIdCounter += 1
  return `temp-${tempIdCounter}`
}

function deriveDisplayedAs(text: string): string {
  const tokens = text.split('-')
  const result: string[] = []
  let i = 0

  while (i < tokens.length) {
    const digit = WORD_TO_DIGIT[tokens[i].toLowerCase()]
    if (digit !== undefined) {
      let digits = digit
      i += 1
      while (i < tokens.length && WORD_TO_DIGIT[tokens[i].toLowerCase()] !== undefined) {
        digits += WORD_TO_DIGIT[tokens[i].toLowerCase()]
        i += 1
      }
      result.push(digits)
    } else {
      result.push(tokens[i])
      i += 1
    }
  }

  return result.join(' ')
}

function addWord() {
  if (!canSubmit.value || loading.value) return

  const rawTerm = form.value.term.trim()
  const text = rawTerm.replace(/\s+/g, '-')

  terms.value.unshift({
    id: nextTempId(),
    text,
    language: form.value.language,
    displayed_as: form.value.displayed_as.trim() || deriveDisplayedAs(text),
    pending: true,
    edited: false
  })

  form.value.term = ''
  form.value.displayed_as = ''
}

// BULK IMPORT
const csvInputRef = ref<HTMLInputElement | null>(null)
const dragOver = ref(false)
const bulkImport = ref<BulkImportState>({ file: null, status: 'idle', progress: 0, loadedBytes: 0, message: '' })

const bulkImportBorderClass = computed(() => {
  if (bulkImport.value.status === 'success') return 'border-[#3DDC84] bg-[#3DDC84]/5'
  if (bulkImport.value.status === 'error') return 'border-elements-red bg-elements-red/5'
  if (bulkImport.value.status === 'uploading') return 'border-elements-blue bg-layer-0'
  if (dragOver.value) return 'border-elements-blue bg-layer-2'
  return 'border-stroke-separator bg-layer-0 hover:border-elements-blue/50'
})

const bulkImportStatusTextClass = computed(() => {
  if (bulkImport.value.status === 'success') return 'text-[#3DDC84]'
  if (bulkImport.value.status === 'error') return 'text-elements-red'
  return 'text-elements-blue'
})

const bulkImportBarClass = computed(() => {
  if (bulkImport.value.status === 'success') return 'bg-[#3DDC84]'
  if (bulkImport.value.status === 'error') return 'bg-elements-red'
  return 'bg-elements-blue'
})

const bulkImportStatusText = computed(() => {
  const b = bulkImport.value
  if (b.status === 'uploading') return 'Uploading...'
  return b.message
})

function formatBytes(bytes: number): string {
  const mb = bytes / (1024 * 1024)
  return `${mb.toFixed(1)} MB`
}

function onDropzoneClick() {
  if (bulkImport.value.file || isVocabSyncing.value) return
  csvInputRef.value?.click()
}

function onFileInputChange(e: Event) {
  const input = e.target as HTMLInputElement
  const file = input.files?.[0]
  if (file) handleCsvFile(file)
  input.value = ''
}

function onFileDrop(e: DragEvent) {
  dragOver.value = false
  const file = e.dataTransfer?.files?.[0]
  if (file) handleCsvFile(file)
}

function resetBulkImport() {
  bulkImport.value = { file: null, status: 'idle', progress: 0, loadedBytes: 0, message: '' }
}

function handleCsvFile(file: File) {
  if (isVocabSyncing.value) return

  const isCsv = file.name.toLowerCase().endsWith('.csv') || file.type === 'text/csv'

  if (!isCsv) {
    bulkImport.value = { file, status: 'error', progress: 100, loadedBytes: file.size, message: 'Please upload a .csv file.' }
    return
  }

  bulkImport.value = { file, status: 'uploading', progress: 0, loadedBytes: 0, message: '' }

  const reader = new FileReader()

  reader.onerror = () => {
    bulkImport.value = { ...bulkImport.value, status: 'error', progress: 100, message: 'Failed to read the file.' }
  }

  reader.onload = () => {
    const text = String(reader.result || '')
    animateBulkImportProgress(file, async () => {
      const outcome = await parseBulkImportCsv(text)
      bulkImport.value = {
        ...bulkImport.value,
        status: outcome.status,
        progress: 100,
        loadedBytes: file.size,
        message: outcome.message
      }
    })
  }

  reader.readAsText(file)
}

function animateBulkImportProgress(file: File, onDone: () => void) {
  const durationMs = 700
  const startedAt = performance.now()

  function step(now: number) {
    const elapsed = now - startedAt
    const progress = Math.min(99, Math.round((elapsed / durationMs) * 100))
    bulkImport.value = { ...bulkImport.value, progress, loadedBytes: Math.round((progress / 100) * file.size) }

    if (elapsed < durationMs) {
      requestAnimationFrame(step)
    } else {
      onDone()
    }
  }

  requestAnimationFrame(step)
}

function isHeaderRow(line: string): boolean {
  const secondColumn = line.split(',')[1]?.trim().toLowerCase()
  return secondColumn === 'phrase' || secondColumn === 'term'
}

async function parseBulkImportCsv(text: string): Promise<{ status: 'success' | 'error', message: string }> {
  const lines = text.split(/\r\n|\n|\r/).map(l => l.trim()).filter(l => l.length > 0)

  if (lines.length && isHeaderRow(lines[0])) {
    lines.shift()
  }

  if (!lines.length) {
    return { status: 'error', message: 'The file is empty.' }
  }

  if (lines.length > MAX_BULK_WORDS) {
    return { status: 'error', message: `The file contains ${lines.length} words, which exceeds the ${MAX_BULK_WORDS} word limit.` }
  }

  const parsedRows = lines
      .map(line => {
        const [langRaw, termRaw, displayedRaw] = line.split(',')
        const rawTerm = (termRaw ?? '').trim()
        const language = (langRaw ?? '').trim() || Constants.DEFAULT_LANGUAGE
        const displayedRawTrimmed = (displayedRaw ?? '').trim()
        return { language, rawTerm, displayedRawTrimmed }
      })
      .filter(row => row.rawTerm.length > 0)

  if (!parsedRows.length) {
    return { status: 'error', message: 'No valid words were found in the file.' }
  }

  const skippedDigits = parsedRows.filter(row => /\d/.test(row.rawTerm)).length
  const nonDigitRows = parsedRows.filter(row => !/\d/.test(row.rawTerm))

  const languagesInFile = [...new Set(nonDigitRows.map(row => row.language))]
  const allowedSets = await Promise.all(languagesInFile.map(lang => getAllowedCharSet(lang)))
  const allowedSetByLanguage = new Map(languagesInFile.map((lang, i) => [lang, allowedSets[i]]))

  const skippedInvalidChars = nonDigitRows.filter(
      row => getInvalidChars(row.rawTerm, allowedSetByLanguage.get(row.language) ?? null).length > 0
  ).length

  const rows = nonDigitRows
      .filter(row => getInvalidChars(row.rawTerm, allowedSetByLanguage.get(row.language) ?? null).length === 0)
      .map(row => {
        const text = row.rawTerm.replace(/\s+/g, '-')
        return {
          language: row.language,
          text,
          displayed_as: row.displayedRawTrimmed || deriveDisplayedAs(text)
        }
      })

  if (!rows.length) {
    return { status: 'error', message: 'None of the rows contained a Term valid for its language — check for numbers or unsupported characters.' }
  }

  rows.forEach(row => {
    terms.value.unshift({
      id: nextTempId(),
      text: row.text,
      language: row.language,
      displayed_as: row.displayed_as,
      pending: true,
      edited: false
    })
  })

  const skippedParts: string[] = []
  if (skippedDigits > 0) skippedParts.push(`${skippedDigits} row${skippedDigits === 1 ? '' : 's'} with numbers`)
  if (skippedInvalidChars > 0) skippedParts.push(`${skippedInvalidChars} row${skippedInvalidChars === 1 ? '' : 's'} with characters unsupported for their language`)
  const skippedMessage = skippedParts.length ? ` Skipped: ${skippedParts.join(', ')}.` : ''

  return { status: 'success', message: `Upload complete! ${rows.length} words added.${skippedMessage}` }
}

// SORT & SEARCH
const sortMode = ref<'new' | 'alphabetical' | 'language'>('new')
const searchQuery = ref('')

const sortOptions = [
  { value: 'new', label: 'New' },
  { value: 'alphabetical', label: 'Alphabetical' },
  { value: 'language', label: 'Language' }
] as const

const filteredTerms = computed(() => {
  const q = searchQuery.value.trim().toLowerCase()
  if (!q) return terms.value
  return terms.value.filter(t => t.text.toLowerCase().includes(q) || t.displayed_as.toLowerCase().includes(q))
})

const visibleTerms = computed(() => {
  if (sortMode.value === 'alphabetical') {
    return [...filteredTerms.value].sort((a, b) => a.text.localeCompare(b.text))
  }
  if (sortMode.value === 'language') {
    return [...filteredTerms.value].sort((a, b) => getLanguageName(a.language).localeCompare(getLanguageName(b.language)))
  }
  // 'new': the API has no created-date field, so this is just insertion order —
  // newly-added pending terms are already unshifted to the front.
  return filteredTerms.value
})

function toggleSelect(id: string) {
  const next = new Set(selectedIds.value)
  if (next.has(id)) {
    next.delete(id)
  } else {
    next.add(id)
  }
  selectedIds.value = next
}

async function deleteSelected() {
  const ids = Array.from(selectedIds.value)
  const savedIds = ids.filter(id => !terms.value.find(t => t.id === id)?.pending)

  try {
    if (savedIds.length) {
      await customVocabularyService.deleteTerms(savedIds)
      localSyncOverride.value = true
    }
    terms.value = terms.value.filter(t => !selectedIds.value.has(t.id))
    selectedIds.value = new Set()
  } catch (err) {
    notifyError(err, 'Failed to delete terms')
  }
}

// INLINE EDIT
const editingId = ref<string | null>(null)
const editDraft = ref({ text: '', displayed_as: '', language: '' })
const editLanguageSelectorOpen = ref(false)
const editLanguageBtnRef = ref<HTMLElement | HTMLElement[] | null>(null)
const editDropdownPos = ref({ left: 0, top: 0, bottom: 0, openUp: false })

const editAllowedSet = ref<Set<number> | null>(null)

watch(() => editDraft.value.language, async (lang) => {
  editAllowedSet.value = lang ? await getAllowedCharSet(lang) : null
}, { immediate: true })

const editHasDigits = computed(() => editingId.value !== null && /\d/.test(editDraft.value.text))
const editInvalidChars = computed(() => editingId.value === null ? [] : getInvalidChars(editDraft.value.text, editAllowedSet.value))
const editInvalidNonDigitChars = computed(() => editInvalidChars.value.filter(c => !/\d/.test(c)))
const editCanConfirm = computed(() => editDraft.value.text.trim().length > 0 && !editHasDigits.value && editInvalidNonDigitChars.value.length === 0)

const editDropdownStyle = computed(() => {
  const pos = editDropdownPos.value
  return pos.openUp
      ? { left: `${pos.left}px`, bottom: `${pos.bottom}px` }
      : { left: `${pos.left}px`, top: `${pos.top}px` }
})

function startEdit(term: VocabularyTerm) {
  if (isVocabSyncing.value) return
  editingId.value = term.id
  editDraft.value = { text: term.text, displayed_as: term.displayed_as, language: term.language }
  editLanguageSelectorOpen.value = false
}

function cancelEdit() {
  editingId.value = null
  editLanguageSelectorOpen.value = false
}

function toggleEditLanguageSelector() {
  const btn = Array.isArray(editLanguageBtnRef.value) ? editLanguageBtnRef.value[0] : editLanguageBtnRef.value

  if (!editLanguageSelectorOpen.value && btn) {
    const rect = btn.getBoundingClientRect()
    editDropdownPos.value = { left: rect.left, top: 0, bottom: window.innerHeight - rect.top + 8, openUp: true }
  }
  editLanguageSelectorOpen.value = !editLanguageSelectorOpen.value
}

function onSelectEditLanguage(code: string) {
  editDraft.value.language = code
  editLanguageSelectorOpen.value = false
}

function confirmEdit(term: VocabularyTerm) {
  if (isVocabSyncing.value || !editCanConfirm.value) return

  const text = editDraft.value.text.trim()

  term.text = text
  term.displayed_as = editDraft.value.displayed_as.trim() || text
  term.language = editDraft.value.language
  if (!term.pending) term.edited = true

  editingId.value = null
  editLanguageSelectorOpen.value = false
}

// DELETE CONFIRMATION
const confirmDeleteOpen = ref(false)

function requestDeleteSelected() {
  if (selectedIds.value.size === 0 || isVocabSyncing.value) return
  confirmDeleteOpen.value = true
}

const confirmDeleteTitle = computed(() => {
  const count = selectedIds.value.size
  return `Delete ${count} selected word${count === 1 ? '' : 's'}?`
})

async function confirmDeleteAction() {
  confirmDeleteOpen.value = false
  await deleteSelected()
}

// SAVE
const hasUnsavedChanges = computed(() => terms.value.some(t => t.pending || t.edited))
const saving = ref(false)

async function saveChanges() {
  if (!hasUnsavedChanges.value || !listId.value || saving.value || isVocabSyncing.value) return

  const pendingTerms = terms.value
      .filter(t => t.pending)
      .map(t => ({ phrase: t.text, display_as: t.displayed_as, language: t.language }))

  const editedTerms = terms.value
      .filter(t => t.edited && !t.pending)
      .map(t => ({ id: t.id, phrase: t.text, display_as: t.displayed_as, language: t.language }))

  saving.value = true
  try {
    if (pendingTerms.length) {
      await customVocabularyService.addTerms(listId.value, pendingTerms)
    }
    if (editedTerms.length) {
      await customVocabularyService.updateTerms(editedTerms)
    }
    localSyncOverride.value = true
    await fetchTerms()
    selectedIds.value = new Set()
    if (toast) toast.success('Vocabulary saved')
  } catch (err) {
    notifyError(err, 'Failed to save vocabulary')
  } finally {
    saving.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _cache[34] || (_cache[34] = _createStaticVNode("<div class=\"mt-8 bg-layer-2 rounded-xl border border-stroke-separator p-4 flex items-start gap-3\" data-v-fa99b538><svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"text-elements-blue shrink-0 mt-0.5\" data-v-fa99b538><circle cx=\"10\" cy=\"10\" r=\"9\" stroke=\"currentColor\" stroke-width=\"1.5\" data-v-fa99b538></circle><path d=\"M10 9v5\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" data-v-fa99b538></path><circle cx=\"10\" cy=\"6.5\" r=\"1\" fill=\"currentColor\" data-v-fa99b538></circle></svg><p class=\"text-sm text-text-neutral-medium\" data-v-fa99b538> Numbers can&#39;t be used in the Term field — they must be spelled out as words, for example &quot;one&quot; instead of &quot;1&quot; or &quot;one-two-three&quot; instead of &quot;123&quot;.<br data-v-fa99b538> Spaces between words will be replaced with &quot;-&quot; when saved.<br data-v-fa99b538> For acronyms, use dots — e.g. &quot;A.S.R.&quot; for &quot;Automatic Speech Recognition&quot;.<br data-v-fa99b538> Allowed characters depend on the Term&#39;s language — unsupported symbols will be rejected. </p></div>", 1)),
    (isVocabSyncing.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[12] || (_cache[12] = [
          _createElementVNode("span", { class: "inline-block w-4 h-4 border-2 border-gray-900 border-t-transparent rounded-full animate-spin shrink-0" }, null, -1),
          _createElementVNode("p", { class: "text-sm text-gray-900" }, " Vocabulary list is syncing. Editing is temporarily disabled until the sync finishes. ", -1)
        ]))]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "flex items-start justify-between gap-4 mb-4" }, [
            _createElementVNode("div", null, [
              _createElementVNode("h2", { class: "text-base font-medium text-text-neutral-extreme" }, "Bulk Import"),
              _createElementVNode("p", { class: "text-sm text-text-neutral-medium mt-1" }, "Populate vocabulary from file")
            ]),
            _createElementVNode("a", {
              href: "/data/example.csv",
              download: "example.csv",
              class: "text-sm text-elements-blue hover:underline shrink-0"
            }, " Example file for import ")
          ], -1)),
          _createElementVNode("div", {
            class: _normalizeClass(["relative flex-1 rounded-xl border-2 border-dashed p-8 flex flex-col items-center justify-center text-center transition-colors", [
                bulkImport.value.file ? 'cursor-default' : 'cursor-pointer',
                bulkImportBorderClass.value,
                isVocabSyncing.value ? 'opacity-50 pointer-events-none' : ''
              ]]),
            onClick: onDropzoneClick,
            onDragover: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (dragOver.value = true), ["prevent"])),
            onDragleave: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (dragOver.value = false), ["prevent"])),
            onDrop: _withModifiers(onFileDrop, ["prevent"])
          }, [
            _createElementVNode("input", {
              ref_key: "csvInputRef",
              ref: csvInputRef,
              type: "file",
              accept: ".csv,text/csv",
              class: "hidden",
              onChange: onFileInputChange
            }, null, 544),
            (!bulkImport.value.file)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[13] || (_cache[13] = _createElementVNode("img", {
                    src: _imports_0,
                    class: "w-12 h-12 mb-4",
                    alt: ""
                  }, null, -1)),
                  _cache[14] || (_cache[14] = _createElementVNode("div", { class: "text-text-neutral-extreme font-medium mb-1" }, "Click to upload CSV or drag and drop", -1)),
                  _cache[15] || (_cache[15] = _createElementVNode("div", { class: "text-sm text-text-neutral-medium" }, "Must contain one word per line", -1))
                ], 64))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "w-full flex items-start gap-3 text-left",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _cache[17] || (_cache[17] = _createElementVNode("div", { class: "w-10 h-10 rounded-lg bg-elements-blue/10 flex items-center justify-center shrink-0" }, [
                    _createElementVNode("img", {
                      src: _imports_1,
                      class: "w-5 h-5",
                      alt: ""
                    })
                  ], -1)),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("span", _hoisted_7, _toDisplayString(bulkImport.value.file.name), 1),
                      _createElementVNode("button", {
                        class: "text-text-neutrals-placeholder hover:text-text-neutrals-primary cursor-pointer shrink-0",
                        onClick: resetBulkImport
                      }, [...(_cache[16] || (_cache[16] = [
                        _createElementVNode("img", {
                          src: _imports_2,
                          class: "w-3 h-3",
                          alt: "Remove"
                        }, null, -1)
                      ]))])
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["flex items-center gap-1.5 text-sm mt-1", bulkImportStatusTextClass.value])
                    }, [
                      (bulkImport.value.status === 'uploading')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8))
                        : _createCommentVNode("", true),
                      (bulkImport.value.status === 'success')
                        ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                        : _createCommentVNode("", true),
                      (bulkImport.value.status === 'error')
                        ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(bulkImportStatusText.value), 1)
                    ], 2),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["h-full rounded-full transition-all duration-150", bulkImportBarClass.value]),
                        style: _normalizeStyle({ width: bulkImport.value.progress + '%' })
                      }, null, 6)
                    ]),
                    (bulkImport.value.status === 'uploading')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("span", null, _toDisplayString(bulkImport.value.progress) + "% completed", 1),
                          _createElementVNode("span", null, _toDisplayString(formatBytes(bulkImport.value.loadedBytes)) + " / " + _toDisplayString(formatBytes(bulkImport.value.file.size)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
          ], 34)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _cache[21] || (_cache[21] = _createElementVNode("h2", { class: "text-base font-medium text-text-neutral-extreme mb-4" }, "Add Individual Word", -1)),
          _createElementVNode("form", {
            onSubmit: _withModifiers(addWord, ["prevent"]),
            class: _normalizeClass(isVocabSyncing.value ? 'opacity-50 pointer-events-none' : '')
          }, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(LanguageSelect, {
                modelValue: form.value.language,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.language) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _cache[19] || (_cache[19] = _createElementVNode("label", { class: "block text-sm text-text-neutral-medium mb-2" }, "Term", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.term) = $event)),
                type: "text",
                required: "",
                placeholder: "e.g. A.I.",
                class: _normalizeClass(["w-full h-11 px-3 border rounded-lg bg-transparent text-text-neutral-extreme placeholder-text-neutrals-placeholder outline-none", (termHasDigits.value || termInvalidNonDigitChars.value.length) ? 'border-elements-red focus:border-elements-red' : 'border-stroke-separator focus:border-elements-blue'])
              }, null, 2), [
                [_vModelText, form.value.term]
              ]),
              (termHasDigits.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_16, " Numbers can't be used in this field. Please spell them out instead, e.g. \"" + _toDisplayString(termDigitsAsWords.value) + "\" instead of \"" + _toDisplayString(termDigits.value) + "\". ", 1))
                : (termInvalidNonDigitChars.value.length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_17, " These characters aren't supported for " + _toDisplayString(_unref(getLanguageName)(form.value.language)) + ": \"" + _toDisplayString(termInvalidNonDigitChars.value.join('", "')) + "\". ", 1))
                  : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _cache[20] || (_cache[20] = _createElementVNode("label", { class: "block text-sm text-text-neutral-medium mb-2" }, "Displayed as", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.displayed_as) = $event)),
                type: "text",
                placeholder: "e.g. Artificial Intelligence",
                class: "w-full h-11 px-3 border border-stroke-separator rounded-lg bg-transparent text-text-neutral-extreme placeholder-text-neutrals-placeholder outline-none focus:border-elements-blue"
              }, null, 512), [
                [_vModelText, form.value.displayed_as]
              ])
            ]),
            _createElementVNode("button", {
              type: "submit",
              disabled: !canSubmit.value || loading.value,
              class: _normalizeClass(["w-full h-11 rounded-lg text-sm font-medium transition-all duration-200", [
                  canSubmit.value && !loading.value ? 'bg-elements-blue hover:bg-opacity-80 text-black cursor-pointer' : 'bg-layer-3 text-text-neutral-medium cursor-default',
                  justEnabled.value ? 'add-btn-pop' : ''
                ]])
            }, " Add ", 10, _hoisted_19)
          ], 34)
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sortOptions, (option) => {
              return _createElementVNode("button", {
                key: option.value,
                type: "button",
                class: _normalizeClass(["px-3 h-8 rounded-md text-sm font-medium transition-colors cursor-pointer", sortMode.value === option.value ? 'bg-elements-blue text-black' : 'text-text-neutral-medium hover:text-text-neutral-extreme']),
                onClick: ($event: any) => (sortMode.value = option.value)
              }, _toDisplayString(option.label), 11, _hoisted_23)
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_24, [
            (hasUnsavedChanges.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("button", {
                    type: "button",
                    disabled: saving.value || isVocabSyncing.value,
                    class: "px-5 h-9 rounded-lg text-sm font-medium bg-elements-blue hover:bg-opacity-80 text-black transition-all duration-200 cursor-pointer disabled:opacity-60 disabled:cursor-default add-btn-pop",
                    onClick: saveChanges
                  }, _toDisplayString(saving.value ? 'Saving...' : 'Save'), 9, _hoisted_25),
                  _cache[22] || (_cache[22] = _createElementVNode("div", { class: "w-px h-6 bg-stroke-separator" }, null, -1))
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_26, [
              _cache[23] || (_cache[23] = _createElementVNode("svg", {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                class: "absolute left-3 top-1/2 -translate-y-1/2 text-text-neutrals-placeholder pointer-events-none"
              }, [
                _createElementVNode("circle", {
                  cx: "7",
                  cy: "7",
                  r: "5.5",
                  stroke: "currentColor",
                  "stroke-width": "1.5"
                }),
                _createElementVNode("path", {
                  d: "M14 14L11.5 11.5",
                  stroke: "currentColor",
                  "stroke-width": "1.5",
                  "stroke-linecap": "round"
                })
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((searchQuery).value = $event)),
                type: "text",
                placeholder: "Search...",
                class: "h-9 pl-9 pr-3 w-48 rounded-lg border border-stroke-separator bg-transparent text-sm text-text-neutral-extreme placeholder-text-neutrals-placeholder outline-none focus:border-elements-blue"
              }, null, 512), [
                [_vModelText, searchQuery.value]
              ])
            ]),
            (selectedIds.value.size > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: _normalizeClass(["px-5 h-9 rounded-lg text-sm font-medium transition-all duration-200", isVocabSyncing.value ? 'bg-layer-2 text-text-neutral-medium cursor-default' : 'bg-elements-blue hover:bg-opacity-80 text-black cursor-pointer']),
                  disabled: isVocabSyncing.value,
                  onClick: requestDeleteSelected
                }, " Delete selected ", 10, _hoisted_27))
              : _createCommentVNode("", true)
          ])
        ]),
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, " Loading vocabulary... "))
          : (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createElementVNode("table", _hoisted_30, [
                _cache[29] || (_cache[29] = _createElementVNode("colgroup", null, [
                  _createElementVNode("col", { style: {"width":"49%"} }),
                  _createElementVNode("col", { style: {"width":"33%"} }),
                  _createElementVNode("col", { style: {"width":"18%"} })
                ], -1)),
                _cache[30] || (_cache[30] = _createElementVNode("thead", { class: "border-b border-stroke-separator text-text-neutral-medium text-xs uppercase" }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { class: "text-left py-4 pl-6 pr-3 font-bold" }, "Language / Word / Abbreviation"),
                    _createElementVNode("th", { class: "text-left py-4 px-3 font-bold" }, "Displayed"),
                    _createElementVNode("th", { class: "text-left py-4 px-3 font-bold" }, "Actions")
                  ])
                ], -1)),
                _createElementVNode("tbody", _hoisted_31, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleTerms.value, (term) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: term.id
                    }, [
                      _createElementVNode("td", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          (term.pending)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_34))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_35, [
                            (editingId.value === term.id)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((editDraft.value.text) = $event)),
                                    type: "text",
                                    class: _normalizeClass(["w-full h-9 px-2 border rounded-lg bg-transparent text-text-neutral-extreme outline-none", (editHasDigits.value || editInvalidNonDigitChars.value.length) ? 'border-elements-red focus:border-elements-red' : 'border-stroke-separator focus:border-elements-blue'])
                                  }, null, 2), [
                                    [_vModelText, editDraft.value.text]
                                  ]),
                                  (editHasDigits.value)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_36, " Numbers aren't allowed — spell them out, e.g. \"one\" instead of \"1\". "))
                                    : (editInvalidNonDigitChars.value.length)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_37, " Unsupported for " + _toDisplayString(_unref(getLanguageName)(editDraft.value.language)) + ": \"" + _toDisplayString(editInvalidNonDigitChars.value.join('", "')) + "\". ", 1))
                                      : _createCommentVNode("", true),
                                  _createElementVNode("button", {
                                    ref_for: true,
                                    ref_key: "editLanguageBtnRef",
                                    ref: editLanguageBtnRef,
                                    type: "button",
                                    class: "flex items-center gap-2 w-full max-w-[220px] h-9 px-2 border border-stroke-separator rounded-lg bg-transparent text-text-neutral-extreme outline-none focus:border-elements-blue cursor-pointer",
                                    onClick: toggleEditLanguageSelector
                                  }, [
                                    _createElementVNode("img", {
                                      src: `/data/flags/${editDraft.value.language}.png`,
                                      alt: editDraft.value.language,
                                      class: "h-5 w-auto rounded-[2px] shrink-0"
                                    }, null, 8, _hoisted_38),
                                    _createElementVNode("span", _hoisted_39, _toDisplayString(_unref(getLanguageName)(editDraft.value.language)), 1),
                                    _cache[24] || (_cache[24] = _createElementVNode("img", {
                                      src: _imports_5,
                                      class: "w-3 h-3 shrink-0",
                                      alt: ""
                                    }, null, -1))
                                  ], 512),
                                  (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                                    (editLanguageSelectorOpen.value)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: "fixed inset-0 z-40",
                                          onClick: _cache[8] || (_cache[8] = ($event: any) => (editLanguageSelectorOpen.value = false))
                                        }))
                                      : _createCommentVNode("", true),
                                    (editLanguageSelectorOpen.value)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 1,
                                          class: "fixed z-50 w-[320px] bg-layer-2 border border-stroke-separator rounded-lg shadow-lg p-3",
                                          style: _normalizeStyle(editDropdownStyle.value)
                                        }, [
                                          _createVNode(LanguagePicker, {
                                            initial: editDraft.value.language,
                                            "close-on-select": false,
                                            onSelect: onSelectEditLanguage
                                          }, null, 8, ["initial"])
                                        ], 4))
                                      : _createCommentVNode("", true)
                                  ]))
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createElementVNode("div", _hoisted_40, _toDisplayString(term.text), 1),
                                  _createElementVNode("div", _hoisted_41, _toDisplayString(_unref(getLanguageName)(term.language)), 1)
                                ], 64))
                          ])
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_42, [
                        (editingId.value === term.id)
                          ? _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 0,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((editDraft.value.displayed_as) = $event)),
                              type: "text",
                              placeholder: "same as Term if not specified",
                              class: "w-full h-9 px-2 border border-stroke-separator rounded-lg bg-transparent text-text-neutral-extreme placeholder-text-neutrals-placeholder outline-none focus:border-elements-blue"
                            }, null, 512)), [
                              [_vModelText, editDraft.value.displayed_as]
                            ])
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(term.displayed_as), 1)
                            ], 64))
                      ]),
                      _createElementVNode("td", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          (editingId.value === term.id)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("button", {
                                  class: "flex items-center gap-1.5 text-text-neutral-extreme hover:text-elements-blue cursor-pointer disabled:opacity-40 disabled:cursor-default disabled:hover:text-text-neutral-extreme",
                                  disabled: !editCanConfirm.value,
                                  onClick: ($event: any) => (confirmEdit(term))
                                }, [...(_cache[25] || (_cache[25] = [
                                  _createElementVNode("img", {
                                    src: _imports_6,
                                    class: "w-3.5 h-3.5",
                                    alt: ""
                                  }, null, -1),
                                  _createTextVNode(" Save ", -1)
                                ]))], 8, _hoisted_45),
                                _createElementVNode("button", {
                                  class: "text-text-neutrals-placeholder hover:text-text-neutrals-primary cursor-pointer",
                                  onClick: cancelEdit
                                }, " Cancel ")
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("button", {
                                  class: "flex items-center gap-1.5 text-text-neutrals-placeholder hover:text-text-neutral-extreme transition-colors cursor-pointer disabled:opacity-40 disabled:cursor-default disabled:hover:text-text-neutrals-placeholder",
                                  disabled: isVocabSyncing.value,
                                  onClick: ($event: any) => (startEdit(term))
                                }, [...(_cache[26] || (_cache[26] = [
                                  _createElementVNode("svg", {
                                    width: "16",
                                    height: "16",
                                    viewBox: "0 0 19 19",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    class: "w-4 h-4"
                                  }, [
                                    _createElementVNode("path", {
                                      d: "M13.9167 7.52369L10.5834 4.19036M1 17.107L3.82031 16.7937C4.16488 16.7554 4.33717 16.7362 4.4982 16.6841C4.64108 16.6378 4.77704 16.5725 4.90241 16.4898C5.04371 16.3966 5.16629 16.2741 5.41144 16.0289L16.4167 5.02369C17.3372 4.10322 17.3372 2.61083 16.4167 1.69036C15.4962 0.769882 14.0038 0.769881 13.0834 1.69035L2.07811 12.6956C1.83296 12.9407 1.71038 13.0633 1.6172 13.2046C1.53453 13.33 1.46918 13.4659 1.42293 13.6088C1.3708 13.7699 1.35165 13.9421 1.31337 14.2867L1 17.107Z",
                                      stroke: "currentColor",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round"
                                    })
                                  ], -1),
                                  _createTextVNode(" Edit ", -1)
                                ]))], 8, _hoisted_46),
                                _createElementVNode("span", _hoisted_47, [
                                  _createElementVNode("input", {
                                    type: "checkbox",
                                    class: "peer absolute inset-0 w-5 h-5 opacity-0 cursor-pointer",
                                    checked: selectedIds.value.has(term.id),
                                    onChange: ($event: any) => (toggleSelect(term.id))
                                  }, null, 40, _hoisted_48),
                                  _cache[27] || (_cache[27] = _createElementVNode("span", { class: "w-5 h-5 rounded-md border border-stroke-resting peer-hover:border-text-neutral-extreme peer-checked:bg-elements-blue peer-checked:border-elements-blue transition-colors pointer-events-none" }, null, -1)),
                                  _cache[28] || (_cache[28] = _createElementVNode("img", {
                                    src: _imports_6,
                                    class: "absolute inset-0 m-auto w-3 h-3 opacity-0 peer-checked:opacity-100 pointer-events-none",
                                    alt: ""
                                  }, null, -1))
                                ])
                              ], 64))
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])),
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("span", null, "Showing " + _toDisplayString(visibleTerms.value.length) + " of " + _toDisplayString(terms.value.length) + " words", 1)
        ])
      ])
    ]),
    _createVNode(SheetModal, {
      modelValue: confirmDeleteOpen.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((confirmDeleteOpen).value = $event)),
      "exact-width": "w-[350px]"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_50, [
          _cache[32] || (_cache[32] = _createElementVNode("img", {
            src: _imports_7,
            class: "w-14 h-14 mb-7"
          }, null, -1)),
          _createElementVNode("h3", _hoisted_51, _toDisplayString(confirmDeleteTitle.value), 1),
          _cache[33] || (_cache[33] = _createElementVNode("p", { class: "text-sm text-white/75 mb-7 text-center" }, "The selected words will be permanently removed from the vocabulary.", -1)),
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("button", {
              onClick: confirmDeleteAction,
              class: "self-stretch px-5 py-2.5 bg-[#FF6566] hover:bg-opacity-30 rounded-xl inline-flex justify-center items-center gap-2 overflow-hidden transition duration-160 cursor-pointer"
            }, [...(_cache[31] || (_cache[31] = [
              _createElementVNode("div", { class: "justify-start text-black text-base font-medium font-['Inter'] leading-normal" }, " Delete ", -1)
            ]))]),
            _createElementVNode("div", {
              onClick: _cache[10] || (_cache[10] = ($event: any) => (confirmDeleteOpen.value = false)),
              class: "text-[#6CBFFF] text-base leading-[1.2rem] font-inter mt-5 mb-2 text-center cursor-pointer"
            }, " Cancel ")
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})